/**
 * Sportconnect — Account drawer Web Component
 * Snazzy Digital Agency
 *
 * Tiroir compte :
 * - Ouverture sur event "sc:account:open" (déclenché par le header)
 * - Form de connexion natif Shopify (form 'customer_login') → submit natif HTTP
 * - Pas d'AJAX : le formulaire recharge la page pour gérer les erreurs et la session
 */

class SCAccountDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-account-drawer]');

    document.addEventListener('sc:account:open', () => this.open());

    this.querySelectorAll('[data-account-close]').forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });
    this.dialog?.addEventListener('click', (e) => {
      if (e.target === this.dialog) this.close();
    });
  }

  open() {
    if (!this.dialog) return;
    this.dialog.showModal();
    setTimeout(() => {
      const firstInput = this.dialog.querySelector('input[type="email"]');
      firstInput?.focus();
    }, 200);
    this.attachSwipeToClose();
  }

  attachSwipeToClose() {
    if (this._swipeAttached) return;
    const dialog = this.dialog;
    if (!dialog) return;
    const handle = dialog.querySelector('[data-drag-handle]');
    if (!handle) return;
    const isMobile = () => window.matchMedia('(max-width: 767.98px)').matches;
    let startY = 0, currentY = 0, dragging = false;
    const onStart = (e) => {
      if (!isMobile()) return;
      const touch = e.touches ? e.touches[0] : e;
      startY = touch.clientY; currentY = 0; dragging = true;
      dialog.style.transition = 'none';
    };
    const onMove = (e) => {
      if (!dragging) return;
      const touch = e.touches ? e.touches[0] : e;
      currentY = Math.max(0, touch.clientY - startY);
      dialog.style.transform = 'translateY(' + currentY + 'px)';
    };
    const onEnd = () => {
      if (!dragging) return;
      dragging = false;
      dialog.style.transition = '';
      dialog.style.transform = '';
      if (currentY > 60) this.close();
    };
    handle.addEventListener('touchstart', onStart, { passive: true });
    handle.addEventListener('touchmove', onMove, { passive: true });
    handle.addEventListener('touchend', onEnd);
    handle.addEventListener('touchcancel', onEnd);
    this._swipeAttached = true;
  }

  close() {
    if (!this.dialog) return;
    this.dialog.dataset.closing = 'true';
    setTimeout(() => {
      if (this.dialog) {
        this.dialog.close();
        delete this.dialog.dataset.closing;
      }
    }, 450);
  }
}

if (!customElements.get('sc-account-drawer')) {
  customElements.define('sc-account-drawer', SCAccountDrawer);
}
